export const GET_MESSENGER_LINK_URL = 'v2/account/messenger-link/max/'

export type Resp = {
  messenger: string
  is_linked: boolean
  display_name?: string
}
